import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-stock-assignments',
  template: `
    <p>
      edit-stock-assignments works!
    </p>
  `,
  styles: ``
})
export class EditStockAssignmentsComponent {

}
